import React from 'react'
import { useTranslation } from 'react-i18next'
import './index.scss'
import { Link } from 'react-router-dom'

export const Breadcrumb = ({
  pathname
}: {
  pathname: string
}) => {

  const { t } = useTranslation()

  let breadcrumbs: { path: string | null, name: string }[] = []

  switch (pathname) {
    case '/contracts/add-contract':
      breadcrumbs = [
        {
          path: '/contracts',
          name: t('NAVBAR.CONTRACTS')
        },
        {
          path: null,
          name: t('NAVBAR.ADD_CONTRACT')
        }
      ]
      break
    case '/repairs-and-inquiries/new-request':
      breadcrumbs = [
        {
          path: '/repairs-and-inquiries',
          name: t('NAVBAR.REPAIRS_AND_INQUIRIES')
        },
        {
          path: null,
          name: t('NAVBAR.NEW_REQUEST')
        }
      ]
      break
    case '/account/edit-theme':
      breadcrumbs = [
        {
          path: '/account',
          name: t('NAVBAR.ACCOUNT')
        },
        {
          path: null,
          name: t('NAVBAR.EDIT_THEME')
        }
      ]
      break
    default:
      breadcrumbs = []
  }

  return (
    <>
      {breadcrumbs?.length > 0 ? (
        <div
          className='breadcrumb-wrapper wrapper'
        >
          {breadcrumbs?.map((breadcrumb, index) => {
            return (
              <div key={index} className='breadcrumb-item'>
                {breadcrumb?.path ? (
                  <>
                    <Link role='link' to={breadcrumb?.path}>{breadcrumb?.name}</Link><span>/</span>
                  </>
                ) : (
                  <p>{breadcrumb?.name}</p>
                )}
              </div>
            )
          })}
        </div>
      ) : (
        <></>
      )}
    </>
  )
}